import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import {LanguageService} from './../../services/LanguageService';
import {LanguageConstants} from './../../common/language/LanguageConstants';


@Component({
    selector: 'popup-component',
    templateUrl: './PopupComponent.html',
})

export class PopupComponent
{

    public language = 'en';
    public languageConstants = LanguageConstants['en'];

    @Input() popupId: string;
    @Input() okButtonText: string = "ok";
    @Input() cancelButtonText: string = "cancel";
    @Input() content: string;

    @Input() okButtonClass: string = '';
    @Input() cancelButtonClass: string = '';

    @Input() showOkButton: boolean = true;
    @Input() showCancelButton: boolean = true;

    @Input() okAction: any;
    @Input() cancelAction: any;

    constructor( private _language: LanguageService)
    {
      this._language.language$.subscribe
            (language =>
            {
                  this.language = language;
                  this.languageConstants = LanguageConstants[this.language];
            });
    }


    ngOnInit(): void
    {
      
    }

    cancel(): void
    {
      this.cancelAction();
    }

    ok(): void {
      this.okAction();
    }


}
